import { get, post } from '@/utils/request'
import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getList = data => post(`${riskApi}/risk/account/level/page`, data)

export const getLevelDelete = data => post(`${riskApi}/risk/account/level/batchDelete`, data)

export const getLevelUpdate = data => post(`${riskApi}/risk/account/level/update`, data)

export const getLevelAdd = data => post(`${riskApi}/risk/account/level/add`, data)

export const getLevelOperationLog = data => post(`${riskApi}/risk/account/levelOperationLog/page`, data)
